import { capitalizeSentenceIfLower } from '@btime/helpers'
import React from 'react'

import { formatBlockReplies } from '../../../../containers/dynamic/presentationList/_helpers/formatBlocks'
import Separator from '../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../components/pdf/Grid'
import GridBar from '../../../../components/pdf/GridBar'
import Text from '../../../../components/pdf/Text'
import Reply from '../_helpers/Reply'
import { getPercent } from '../_helpers/_helpers'

const Replies = ({ replies }) => {
  replies = formatBlockReplies(replies)

  return replies.map(reply => <Reply key={reply.id} reply={reply} />)
}

const RepliesSection = ({ categories }) => {
  return categories.map(category => (
    <div key={category.id}>
      <Separator weight={8} />
      <GridBar>
        <Col flex={1}>
          <Text size="h5" bold>
            {capitalizeSentenceIfLower(category.name)}
          </Text>
        </Col>
        <Col>
          <Grid justify="center" gutter={3}>
            <Col gutter={3}>
              <Text>Pontuação:</Text>
            </Col>
            <Col gutter={3}>
              <Text bold inline>
                {`${getPercent(category.totalOfValues, category.totalOfPoints)}%`}
              </Text>
              <Text inline preLine style={{ whiteSpace: 'break-spaces' }}>
                {' '}
                de{' '}
              </Text>
              <Text bold inline>
                100%
              </Text>
            </Col>
          </Grid>
        </Col>
      </GridBar>

      <Separator weight={4} />

      <Replies replies={category.replies} />
    </div>
  ))
}

export default RepliesSection
